import { render } from "./EllipsisButton.vue?vue&type=template&id=1f34b1ce"
import script from "./EllipsisButton.vue?vue&type=script&lang=js"
export * from "./EllipsisButton.vue?vue&type=script&lang=js"
script.render = render

export default script